import { PageHeader, PageBody, OverlayLoader } from "../../common";
import RegistrationForm from "./RegistrationForm";
import { useSearchParams } from "react-router-dom";
import { useMutationWrapper } from "../../../hooks";
import { MprService } from "../../../openapi/edsn-webapi";
import { useEffect } from "react";

const RegistrationFormPage = () => {
  const [searchParams, _] = useSearchParams();
  const id = searchParams.get("id");
  const token = searchParams.get("token");
  const { mutate, isPending, isIdle, data } = useMutationWrapper(
    ["getMpr"],
    ({ id, token }: { id: string; token: string }) => {
      return MprService.getMprCreate({ id, token });
    }
  );
  const showLoader = !!id && !!token && (isIdle || isPending);

  useEffect(() => {
    if (id && token) {
      mutate({ id, token });
    }
  }, [id, token, mutate]);
  return (
    <>
      <PageHeader maxWidth="md" title="createRegistrationTitle" />
      <PageBody maxWidth="md">
        {showLoader ? (
          <OverlayLoader />
        ) : (
          <RegistrationForm defaultValues={data} id={id} token={token} />
        )}
      </PageBody>
    </>
  );
};

export default RegistrationFormPage;
